import camelCase from 'lodash/camelCase';
import mapKeys from 'lodash/mapKeys';
import {createCartItem} from '~/data/records/CartItem';
import remoteServices from '~/constants/RemoteServices';
import {buildUrl} from '~/utils/url';

export function deserialize(data) {
  data = mapKeys(data, (value, key) => camelCase(key));
  let cartItems = data.items || [];
  let total = 0;
  cartItems = cartItems.reduce((acc, cartItem) => {
    let item = mapKeys(cartItem, (_value, key) => camelCase(key));
    let imageUrl = `/images/catalog/colors/${item.colorId}/views/alt/front_medium_extended.png`;
    imageUrl = `${remoteServices.proofImages}${imageUrl}`;
    item.imageSrc = buildUrl(imageUrl, {
      design: item.designCompositeId,
      digest: item.designUpdatedAt
    });
    item = createCartItem(item);
    acc[item.id] = item;
    total = total + item.subTotal;
    return acc;
  }, {});
  const email = data.account.email;
  return {email, items: cartItems, total};
}
